import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class GeteventsService {
  constructor() { 

  }

  public array_events:Events[]=[];

  public async getEvents(espid: string, timeini: number, timefin: number){
    //Cargamos la apirest de Amplify
    const response = await this.getData(espid, timeini, timefin);
    return response.data.Items; // Valor que devolvemos
  }


  getData(espid: string, timeini: number, timefin: number) { 
    const apiName = 'PharaonAmicareEventsApi';
    const path = '/events';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,//'CARM100508', 
        timeini: timeini, //1630060314343,  //1630060314344
        timefin: timefin, //1630060314349
      },
  };

    return API.get(apiName, path, myInit);

  }
  

}

export interface Events{
  espid : string;
  timestamp: number;
  pir: string;
  cama1: string;

}